import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const Panel = ({ title, checks, delay, testId }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay }}
        data-testid={testId}
        className="rounded-2xl border border-border bg-card p-8 shadow-sm"
    >
        <h3 className="font-heading font-semibold text-lg text-foreground">{title}</h3>
        <ul className="mt-6 space-y-3">
            {checks.map((c, i) => (
                <motion.li
                    key={c} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: delay + 0.15 + i * 0.08 }}
                    className="flex items-center gap-2.5 text-sm text-foreground"
                >
                    <BadgeCheck size={17} className="text-emerald-500 shrink-0" /> {c}
                </motion.li>
            ))}
        </ul>
    </motion.div>
);

export const TrustScorePanel = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Panel
            title="Candidate verifications"
            delay={0}
            testId="trust-score-candidate"
            checks={["Email Verified", "Phone Verified", "Identity Verified", "Employment Verified", "Reference Verified"]}
        />
        <Panel
            title="Employer verifications"
            delay={0.15}
            testId="trust-score-employer"
            checks={["Company Email Verified", "Business Verified", "Hiring Manager Verified"]}
        />
    </div>
);

export default TrustScorePanel;
